import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  display: block;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 16px;
`;

export const Tools = styled.div`
  position: absolute;
  top: 2px;
  left: 2px;
  display: flex;
  z-index: 2;
`

export const Post = styled.div`
  transition: all 200ms;
  place-self: stretch;
  margin-left: 3px;
  margin-right: 3px;
  background-color: ${({ theme }) => theme.colors.postnav.background};
  border: 1px solid ${({ theme }) => theme.colors.postnav.outline};
  border-radius: 3px;
  box-shadow: 0 3px 8px 0 rgba(116,129,141,.5);

  button {
    display: flex;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 2px;
    background-color: inherit;

    svg {
      flex: 0 0 auto;
      width: 25px;
      height: 25px;
      color: ${({ theme }) => theme.colors.postnav.link};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.postnav.backgroundActive};

    button svg {
      color: ${({ theme }) => theme.colors.postnav.linkActive};
    }
  }
`;

export const Location = styled.span`
  a {
    svg {
      width: 30px;
      height: 30px;
      color: ${({ theme }) => theme.colors.postnav.background};
    }

    &:focus {
      svg {
        color: ${({ theme }) => theme.colors.postnav.backgroundActive};
      }
    }
  }

  &:hover {
    a svg {
      color: ${({ theme }) => theme.colors.postnav.backgroundActive};
    }
  }
`